var _style, _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n\t.st1{fill:none;stroke:#5BF4C1;stroke-width:1.9;stroke-miterlimit:10;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#5BF4C1;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "And") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35,
    cy: 34.5,
    r: 34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35,
    cy: 34.5,
    r: 27.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.1,38.5c0-2.9,1.7-4.9,4-6.1c-1.7-1.1-2.8-2.9-2.8-4.9c0-3.9,3.4-6.7,7.8-6.7c4.3,0,7.7,2.8,7.7,6.7 c0,2.1-1.1,3.8-2.8,4.9c0.8,0.3,1.6,0.8,3.6,3.3l3.7-4.6h4.9l-6,7.5l5.9,7.3h-4.8l-3.6-4.4c-3.5,3.8-5.7,4.8-8.9,4.8 C27.6,46.2,24.1,42.9,24.1,38.5z M39.2,38.5c-2.8-3.6-4.3-4.4-6.2-4.4c-2.6,0-4.6,1.8-4.6,4.4c0,2.5,1.9,4.4,4.6,4.4 C34.7,43,36.4,42.2,39.2,38.5z M36.6,27.5c0-2.1-1.4-3.5-3.5-3.5c-2.1,0-3.6,1.5-3.6,3.5c0,2,1.4,3.5,3.6,3.5 C35.2,31,36.6,29.5,36.6,27.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnd);
export default __webpack_public_path__ + "static/media/And.d366e9f21e59e75f3ff7acaa817348b7.svg";
export { ForwardRef as ReactComponent };